import InterfaceLogin from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/login-logout/interface-login.svg';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import styled from 'styled-components';
import { BouTextAndIcon } from '../../../bou-text-and-icon';
import { InternalLinkItem } from './shared';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { navFastTransition } from './shared';

export function LoginItem() {
  return (
    <StyledInternalLink id={E2eTestElementId.LOGIN} to="/login">
      <BouTextAndIcon text="Login" slIcon={<InterfaceLogin />} />
    </StyledInternalLink>
  );
}

const StyledInternalLink = styled(InternalLinkItem)`
  ${getTextStyle({ size: 'xxxs' })}
  font-weight: 600;
  padding: 0.6em 1em;
  color: ${BouColor.PLATFORM_TEXT_WHITE};
  background-color: ${BouColor.PLATFORM_BG_GRAY};
  border: 1px solid ${BouColor.PLATFORM_BORDER_GRAY_DARK};
  border-radius: 6px;
  transition: all ${navFastTransition};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;

  &:hover {
    background-color: ${BouColor.PLATFORM_BG_GRAY};
    border-color: ${BouColor.PLATFORM_BORDER_GRAY};
    color: ${BouColor.PLATFORM_TEXT_WHITE};
  }

  &:active {
    background-color: ${BouColor.PLATFORM_BG_GRAY_DARK};
  }
`;
